import SocketConnection from "itoeste-socket"
import { DEBUG, API_SOCKET } from "../../env";
let _SOCKET
// solo conecta fuera de debug y con token presente (lo inyecta el build, ver env.js)
if(!DEBUG && API_SOCKET){
	_SOCKET = SocketConnection({
		debug:DEBUG,
		token:API_SOCKET
	},()=>{

	});
}

export default _SOCKET
